import type { Scenario } from '../data/types';
import styles from './ScenarioList.module.css';

interface ScenarioListProps {
  scenarios: Scenario[];
  inProgress: Record<string, boolean>;
  completed: Record<string, boolean>;
  onPlay: (id: string) => void;
}

export function ScenarioList({ scenarios, inProgress, completed, onPlay }: ScenarioListProps) {
  return (
    <section className={styles.list}>
      <header className={styles.intro}>
        <h1 className={styles.heading}>the negotiation sim</h1>
        <p className={styles.subtitle}>practice saying yes, no, and not yet</p>
        <p className={styles.body}>
          five short interactive scenarios. read paragraph by paragraph; choose
          how you respond. there is no right path. each scenario takes a few
          minutes. it ends with a brief reflection on what was practiced and
          what other choices you could have made.
        </p>
      </header>

      <ol className={styles.scenarios}>
        {scenarios.map((scenario, i) => (
          <li key={scenario.id} className={styles.scenarioCard}>
            <span className={styles.scenarioIndex}>{String(i + 1).padStart(2, '0')}</span>
            <div className={styles.scenarioBody}>
              <h2 className={styles.scenarioTitle}>{scenario.title}</h2>
              <p className={styles.scenarioBrief}>{scenario.brief}</p>
              <p className={styles.scenarioMeta}>
                <span className={styles.skill}>skill: {scenario.skill}</span>
                <span className={styles.dur}>~{scenario.estMinutes} min</span>
              </p>
            </div>
            <div className={styles.actions}>
              {inProgress[scenario.id] && (
                <button type="button" className={styles.resume} onClick={() => onPlay(scenario.id)}>
                  resume
                </button>
              )}
              {!inProgress[scenario.id] && (
                <button type="button" className={styles.play} onClick={() => onPlay(scenario.id)}>
                  {completed[scenario.id] ? 'replay' : 'begin'}
                </button>
              )}
              {completed[scenario.id] && <span className={styles.done}>✓ played</span>}
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
